import * as Icons from "lucide-react";

export const Icon = ({ name, ...props }) => {
  const Cmp = Icons[name] || Icons.Shield;
  return <Cmp {...props} />;
};
